
import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ApiGateway, PageOptions } from 'cw-backend';
import { CwUtils } from 'cw-utils';
import { BehaviorSubject, Observable } from 'rxjs';
import { ThirdParty } from '../../../models/register/organizational/third-party';

@Injectable()
export class ThirdPartyListProvider implements Resolve<any> {
    thirdParty: ThirdParty[];
    thirdPartyEdit: ThirdParty;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(
        public gw: ApiGateway,
        private location: Location,
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        this.currentPage = this.state?.currentPage;
        this.thirdPartyEdit = this.state?.currentThirdParty;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
        }
        else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = 'id';
        }
        return new Promise((resolve, reject) => {
            Promise.all([
                this.getPage(this.pageOptions)
            ]).then(
                () => {
                    resolve(true);
                },
                reject
            );
        });
    }

    get(id: number): Observable<ThirdParty> {
        if (!id) {
            return null;
        }
        return this.gw.get('thirdParty/:id', { id: id });
    }

    get currentThirdParty(): ThirdParty {
        return this.thirdPartyEdit;
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('thirdParty/').subscribe({
                next: (res: HttpResponse<any>) => {
                    this.thirdParty = res.body;
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        });

    }

    getPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('thirdParty/search', pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    if (!CwUtils.compare(this.thirdParty, res.body.content) && res.body.content.length > 0) {
                        this.thirdParty = res.body.content;
                        this.onDataChanged.next(this.thirdParty);
                    }
                    else {
                        this.thirdParty = res.body.content;
                    };
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        });
    }

    getPageSimple(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('thirdParty/searchSimple', pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    if (!CwUtils.compare(this.thirdParty, res.body.content) && res.body.content.length > 0) {
                        this.thirdParty = res.body.content;
                        this.onDataChanged.next(this.thirdParty);
                    }
                    else {
                        this.thirdParty = res.body.content;
                    };
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        });
    }


    getPageOrderItemThirdParty(pageOptions: PageOptions, orderItemId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post(`orderItemThirdParty/search/${orderItemId}`, pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        });
    }

    getParticipationPage(pageOptions: PageOptions, thirdPartyId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post(`thirdParty/searchParticipation/${thirdPartyId}`, pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        });
    }

    getThirdPartyParticipation(thirdPartyId: number, procedureId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get(`thirdParty/searchParticipation/${thirdPartyId}/${procedureId}`).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        });
    }

    getAuthorizedByParticipation(participationId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get(`thirdPartyAuthorized/participation/${participationId}`).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }
}

